import React, { useState } from 'react'
import {
  Box,
  ToggleButtonGroup,
  TextField,
  InputAdornment
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import notebook from '../../assets/icons/notebook.svg'
import { topBarStyles } from '../../styles/classes/FormBuilderClasses'
import { statusOptions } from '../../utils/fieldForms'

import {
  StyledButton,
  StyledToggleButton
} from '../../styles/mui_custom_components'
import { capitalize } from '../../utils/global'

const TopBar = ({
  status,
  onToggleChange,
  onBack,
  formName,
  onFormNameChange
}) => {
  const { t } = useTranslation()
  const { classes } = topBarStyles()
  const [disabledEdit, setDisabledEdit] = useState(true)

  const enterPressHandler = e => {
    if (e.keyCode === 13) {
      setDisabledEdit(true)
    }
  }
  const statusName =
    status === statusOptions.PUBLISHED ? 'Published' : capitalize(status)
  return (
    <Box className={classes.container}>
      <Box className={classes.leftContainer}>
        <StyledButton
          startIcon={<ArrowBackIosIcon />}
          onClick={onBack}
          className={classes.backButton}
        >
          Back
        </StyledButton>
        <TextField
          className={classes.formTitleStyle}
          fullWidth
          onClick={() => {
            setDisabledEdit(false)
          }}
          onBlur={() => {
            setDisabledEdit(true)
          }}
          inputRef={input => input && input.focus()}
          value={formName}
          onChange={onFormNameChange}
          disabled={disabledEdit}
          onKeyDown={enterPressHandler}
          variant="standard"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                {' '}
                <img
                  src={notebook}
                  className={classes.lockIcon}
                  alt="notebook icon"
                />
              </InputAdornment>
            ),
            disableUnderline: true
          }}
        />
      </Box>

      <ToggleButtonGroup
        size="small"
        disabled
        value={statusName}
        exclusive
        onChange={onToggleChange}
        aria-label="Status"
      >
        <StyledToggleButton value="Draft">
          {t('form_builder.top_bar.draft')}
        </StyledToggleButton>
        <StyledToggleButton value="Published">
          {t('form_builder.top_bar.published')}
        </StyledToggleButton>
        <StyledToggleButton value="Inactive">
          {t('form_builder.top_bar.inactive')}
        </StyledToggleButton>
      </ToggleButtonGroup>
    </Box>
  )
}

export default TopBar
